@if (applicationResource == null) {
  <div class="loading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
} @else {
  <mat-card>
    <mat-card-header class="table-header">
      <mat-card-title>Documentos de la Aplicación</mat-card-title>
      <mat-card-subtitle>
        <app-application-outline
          [applicationResource]="applicationResource"></app-application-outline>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div fxLayout="column">
        <div class="input-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
          <div class="mat-elevation-z8" *ngIf="this.dataSource.data.length > 0">
            <table mat-table [dataSource]="dataSource"
                   class="applications-table">
              <ng-container matColumnDef="documentType">
                <th mat-header-cell *matHeaderCellDef>Tipo de Documento</th>
                <td mat-cell *matCellDef="let element"> {{ element.documentType }}</td>
              </ng-container>
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Descripción</th>
                <td mat-cell *matCellDef="let element"> {{ element.description }}</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element"> OK</td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let element">
                  <div class="actions">
                    @if ((element.documentType == 'POLIZA' && roles.includes('business-agent'))
                    || element.documentType != 'POLIZA') {
                      <a matButton (click)="downloadFile(element.id)">
                        <mat-icon fontIcon="download"></mat-icon>
                      </a>
                    }
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                           aria-label="Select page of applications">
            </mat-paginator>
          </div>
          @if (this.dataSource.data.length == 0) {
            <div class="no-data">
              <p>No hay documentos cargados</p>
            </div>
          }
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions align="end">
      @if (applicationResource.status == 'IN_PROGRESS' || applicationResource.status == 'NEW') {
        <button mat-raised-button color="primary" (click)="uploadFile()">Subir documento</button>
      }
    </mat-card-actions>
  </mat-card>
}
